module.exports = __webpack_public_path__ + "image-d7a4f93340b9.png";